// @flow
import initialState from "./initialState";
import * as ActionTypes from "../actions/actionTypes";
import { Cart, EntityList } from "../flow/types";

export default function (
    state: EntityList<Cart>  = initialState.carts,
    action: any
) {
    switch (action.type) {
        case ActionTypes.GET_CARTS + ActionTypes.FULFILLED:
            var data = action.payload.data;
            return new EntityList(
                data.items,
                data.totalCount
            );

        case ActionTypes.REMOVE_CART + ActionTypes.FULFILLED:
            const filteredCarts = state.items.filter(cart => cart.url !== action.payload.data);
             return new EntityList(
                filteredCarts,
                filteredCarts.length
            );;
        default:
            return state;
    }
}